import { useState, useCallback } from 'react';
import { clearAvailabilityCache } from '../../../utils/availabilityCache';

/** Bumps timeline/preview fetches after clearing client-side availability cache for a venue. */
export const useAvailabilityRefresh = (venueId) => {
  const [availabilityRefreshTick, setAvailabilityRefreshTick] = useState(0);
  const [availabilityRefreshing, setAvailabilityRefreshing] = useState(false);

  const refreshAvailability = useCallback(() => {
    if (!venueId) return;
    setAvailabilityRefreshing(true);
    clearAvailabilityCache(venueId);
    setAvailabilityRefreshTick((tick) => tick + 1);
    setAvailabilityRefreshing(false);
  }, [venueId]);

  return {
    availabilityRefreshTick,
    availabilityRefreshing,
    refreshAvailability
  };
};
